/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_TotalInputs */

const vi_einvoice_draft_total = /** @type {(inputs: Einvoice_Draft_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng thanh toán`)
};

/**

* @param {Einvoice_Draft_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_total = /** @type {((inputs?: Einvoice_Draft_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_total(inputs)
});